import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PlaceInfoPage } from './place-info.page';

const routes: Routes = [
    {
        path: '',
        component: PlaceInfoPage,
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class PlaceInfoPageRoutingModule {}
